import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { fetchXceedEvents } from '../utils/api'
import useTranslation from '../hooks/useTranslation'

const XceedEvents = () => {
  const { t, language } = useTranslation();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(language === 'en' ? 'en-US' : language === 'de' ? 'de-DE' : 'es-ES', options);
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch events from our backend proxy; use fallback data if backend is unavailable
        const eventsData = await fetchXceedEvents();

        // Sort events by date
        const now = Math.floor(Date.now() / 1000); // Current time in seconds

        // Filter and sort upcoming events (startingTime > now)
        const upcoming = eventsData.filter(event => event.startingTime > now)
          .sort((a, b) => a.startingTime - b.startingTime);

        // Filter and sort past events (startingTime <= now)
        const past = eventsData.filter(event => event.startingTime <= now)
          .sort((a, b) => b.startingTime - a.startingTime); // Most recent first

        // For homepage, limit to all upcoming events and only 3 past events
        setUpcomingEvents(upcoming);
        setPastEvents(past.slice(0, 3)); // Only show the 3 most recent past events
        setLoading(false);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('Unable to fetch live events. Using sample event data.');
        setLoading(false);

        // Fallback data if API fails
        setUpcomingEvents([
          {
            id: "d6b43128-250e-11f0-9146-0242ac110015",
            legacyId: 189673,
            name: "Coda x AURA",
            slug: "coda-x-aura",
            startingTime: 1746907200,
            coverUrl: "https://images.xceed.me/events/banners/coda-x-aura-hamburg-xceed-4edc.jpg",
            venue: {
              name: "Coda Club",
              city: {
                name: "Hamburg",
                slug: "hamburg",
                country: {
                  name: "Germany"
                }
              }
            }
          },
          {
            id: "4e570340-2460-11f0-ba35-0242ac110019",
            legacyId: 189513,
            name: "Nikki Tiger Friday presents TWIIN FLAME",
            slug: "nikki-tiger-friday-presents-twiin-flame",
            startingTime: 1747432500,
            coverUrl: "https://images.xceed.me/events/banners/nikki-tiger-friday-presents-twiin-flame-hamburg-xceed-1b16.png",
            venue: {
              name: "Nikki Tiger",
              city: {
                name: "Hamburg",
                slug: "hamburg",
                country: {
                  name: "Germany"
                }
              }
            }
          }
        ]);

        setPastEvents([
          {
            id: "6d51f874-214d-11f0-8ec3-0242ac11000a",
            legacyId: 189220,
            name: "CODA x ROOTS PRES. TANZ IN DEN MAI",
            slug: "coda-x-roots-pres-tanz-in-den-mai",
            startingTime: 1746043200,
            coverUrl: "https://images.xceed.me/events/banners/coda-x-roots-pres-tanz-in-den-mai-hamburg-xceed-068f.png",
            venue: {
              name: "Coda Club",
              city: {
                name: "Hamburg",
                slug: "hamburg",
                country: {
                  name: "Germany"
                }
              }
            }
          },
          {
            id: "c67587b0-1aca-11f0-9c0c-0242ac110003",
            legacyId: 188201,
            name: "FOR US X GET CLOSER @CODA",
            slug: "for-us-x-get-closer-coda",
            startingTime: 1745697600,
            coverUrl: "https://images.xceed.me/events/banners/for-us-x-get-closer-coda-hamburg-xceed-2fca.png",
            venue: {
              name: "Coda Club",
              city: {
                name: "Hamburg",
                slug: "hamburg",
                country: {
                  name: "Germany"
                }
              }
            }
          }
        ]);
      }
    };

    fetchEvents();
  }, []);

  return (
    <div>
      <div style={{
        maxWidth: '100%',
        margin: '0 auto 20px auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
        backgroundColor: '#111',
        borderRadius: '4px',
        padding: '30px'
      }}>
        <h3 style={{ marginBottom: '20px', textAlign: 'center' }}>{t('shows.subtitle')}</h3>
        <p style={{ marginBottom: '20px', textAlign: 'center', fontStyle: 'italic' }}>
          "{t('shows.tagline')}"
        </p>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <p>{t('shows.loading')}</p>
          </div>
        ) : (
          <>
            <h4 style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'left' }}>{t('shows.upcomingEvents')}</h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              maxWidth: '800px',
              margin: '0 auto 30px'
            }}>
              {upcomingEvents.length > 0 ? (
                upcomingEvents.map(event => (
                  <div
                    key={event.id}
                    style={{
                      padding: '20px',
                      backgroundColor: '#222',
                      borderRadius: '4px',
                      textAlign: 'left',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{
                        backgroundImage: `url(${event.coverUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '80px',
                        height: '80px',
                        borderRadius: '4px'
                      }}></div>
                      <div>
                        <h4 style={{ margin: '0' }}>{event.name}</h4>
                        <p style={{ color: '#ccc', margin: '5px 0' }}>
                          {formatDate(event.startingTime)} | {event.venue.city.name}, {event.venue.city.country.name}
                        </p>
                        <p style={{ margin: '5px 0' }}>{event.venue.name}</p>
                      </div>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <a
                        href={`https://xceed.me/en/${event.venue.city.slug}/event/${event.slug}--${event.legacyId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'inline-block',
                          padding: '8px 15px',
                          backgroundColor: '#fff',
                          color: '#000',
                          fontWeight: 'bold',
                          borderRadius: '25px',
                          textDecoration: 'none',
                          fontSize: '0.9rem'
                        }}
                      >
                        {t('shows.getTickets')}
                      </a>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p>{t('shows.noUpcoming')}</p>
                </div>
              )}
            </div>

            <h4 style={{ marginTop: '40px', marginBottom: '20px', textAlign: 'left' }}>{t('shows.pastEvents')}</h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {pastEvents.length > 0 ? (
                pastEvents.map(event => (
                  <div
                    key={event.id}
                    style={{
                      padding: '20px',
                      backgroundColor: '#222',
                      borderRadius: '4px',
                      textAlign: 'left',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      opacity: '0.7'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{
                        backgroundImage: `url(${event.coverUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '80px',
                        height: '80px',
                        borderRadius: '4px'
                      }}></div>
                      <div>
                        <h4 style={{ margin: '0' }}>{event.name}</h4>
                        <p style={{ color: '#ccc', margin: '5px 0' }}>
                          {formatDate(event.startingTime)} | {event.venue.city.name}, {event.venue.city.country.name}
                        </p>
                        <p style={{ margin: '5px 0' }}>{event.venue.name}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p>{t('shows.noPast')}</p>
                </div>
              )}
            </div>
          </>
        )}

        {error && (
          <div style={{
            textAlign: 'center',
            padding: '10px',
            marginTop: '20px',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            borderRadius: '4px'
          }}>
            <p>{error}</p>
          </div>
        )}
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/shows">
          <button style={{ marginTop: '10px' }}>{t('home.events.viewAll')}</button>
        </Link>
      </div>
    </div>
  )
}

export default XceedEvents
